import { useCallback } from "react";
import { useSearchParams } from "react-router";
import { RouteObject } from "react-router";
import { useIsFetching, useQueryClient } from "@tanstack/react-query";

import { Button, ButtonStyle, PageHeading, RefreshIcon, Spinner } from "@prequel/shared-components";

import ActivitiesTable from "@/components/ActivitiesTable";

const ActivityPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const queryClient = useQueryClient();

  const refreshTable = useCallback(() => {
    const params = new URLSearchParams(searchParams);
    params.delete("cursor");
    params.delete("page_size");
    setSearchParams(params);
    queryClient.invalidateQueries({
      queryKey: ["destination-activities"],
    });
  }, [searchParams, setSearchParams, queryClient]);

  const isRefreshing = useIsFetching({
    queryKey: ["destination-activities"],
  });

  const RefreshButton = () => {
    return (
      <div className="flex items-center">
        <RefreshIcon className="size-4" />
        <span className="ml-2">Refresh</span>
      </div>
    );
  };

  const RefreshButtonOrSpinner = () => {
    return (
      <Button
        onClick={refreshTable}
        type={ButtonStyle.TERTIARY}
        text={isRefreshing ? <Spinner.Inline /> : <RefreshButton />}
      />
    );
  };

  return (
    <div className="h-full flex-col">
      <div className="max-w-6xl px-7 py-4 pb-16">
        <PageHeading title="Activity">
          <RefreshButtonOrSpinner />
        </PageHeading>
        <ActivitiesTable />
      </div>
    </div>
  );
};

export const activityRoutes: RouteObject = {
  path: "activity",
  handle: {
    breadcrumb: () => ({ label: "Activity" }),
  },
  element: <ActivityPage />,
};

export default ActivityPage;
